import equal from "react-fast-compare";
export function deepEqual<T>(a: T, b: T): boolean {
  return equal(a, b);
}
export function jsonEqual(a: any, b: any) {
  return a === b || JSON.stringify(a) === JSON.stringify(b);
}
